<template>
  <jet-form-section @submitted="updateBilling">
    <template #title>Billing Information</template>

    <template #description>
      Default Payment Method and Automatic Payment Settings
    </template>

    <template #form>
      <jet-action-message :on="form.recentlySuccessful">Saved.</jet-action-message>


      <PaymentMethodUpdate
        :updateMethodRoute="route('orders.updatepaymentmethod')"
        :payment="payment" 
        :has_linked="has_linked"
      />
    </template>

  </jet-form-section>
</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'

import PaymentMethodUpdate from '@/Components/Payment/PaymentMethodUpdate'
import InputSwitch from 'primevue/inputswitch';

export default {
  components: {
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
    PaymentMethodUpdate,
    InputSwitch,
  },

  props: ['payment', 'has_linked',],

  data() {
    return {
      form: this.$inertia.form({
        current_password: '',
        password: '',
        password_confirmation: '',
      }),
    }
  },

  methods: {
    updateBilling() {
    },
  },
}
</script>
